import { addParamsToUrl } from '@zapier/url-utils';
import {
  buildEntityActions,
  buildEntityApi,
  buildEntitySelectors,
} from '@zapier/toolbox-redux-framework';

import { AUDIT_LOGS_LIMIT } from 'app/developer-v3/pages/history/constants';
import { selectAppIdOrWb } from 'app/developer-v3/selectors';

export const type = 'cliAppAuditLog';

export const api = buildEntityApi(type, (_path, getState) => {
  const state = getState();
  const { appId } = selectAppIdOrWb(state);

  const baseUrl = `/api/platform/cli/apps/${appId}/history`;
  const params = { limit: AUDIT_LOGS_LIMIT };
  return addParamsToUrl(baseUrl, params);
});

export const selectors = buildEntitySelectors(type, () => {});

export const actions = buildEntityActions(type, selectors, api);
